module.exports = __webpack_public_path__ + "img/20180815_145537_013.65dc891d.jpg";